/**
 * @desc 根据工号列表推送组织架构员工信息
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.OrganizationStaffPushRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/push`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
